export { default as Images } from "./Images";
